import { actions } from './actions'

const initialState = {
  carteles: {
    data: [],
    loading: false,
    error: '',
  },
  cartel: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function cartelReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CARTELES_LOAD_REQUESTED:
      return { ...state, carteles: { ...state.carteles, loading: true } }
    case actions.CARTELES_LOAD_SUCCEEDED:
      return { ...state, carteles: { ...state.carteles, data: action.payload, loading: false } }
    case actions.CARTELES_LOAD_FILED:
      return { ...state, carteles: { ...state.carteles, loading: false, error: action.error } }
    case actions.CARTEL_UPDATE_REQUESTED:
      return {
        ...state,
        carteles: { ...state.carteles, loading: true, error: '' },
      }
    case actions.CARTEL_UPDATE_SUCCEEDED:
      return {
        ...state,
        carteles: {
          ...state.carteles,
          data: state.carteles.data.map(pais =>
            pais.id === action.payload.id ? action.payload : pais,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.CARTEL_UPDATE_FILED:
      return {
        ...state,
        carteles: { ...state.carteles, loading: false, error: action.error },
      }
    case actions.CARTEL_INSERT_REQUESTED:
      return {
        ...state,
        carteles: { ...state.carteles, loading: true, error: '' },
      }
    case actions.CARTEL_INSERT_SUCCEEDED:
      return {
        ...state,
        carteles: {
          ...state.carteles,
          data: [].concat(action.payload, state.carteles.data),
          loading: false,
          error: '',
        },
      }
    case actions.CARTEL_INSERT_FILED:
      return {
        ...state,
        carteles: { ...state.carteles, loading: false, error: action.error },
      }
    case actions.CARTEL_DELETE_REQUESTED:
      return {
        ...state,
        carteles: { ...state.carteles, loading: true, error: '' },
      }
    case actions.CARTEL_DELETE_SUCCEEDED:
      return {
        ...state,
        carteles: {
          ...state.carteles,
          data: state.carteles.data.filter(pais => pais.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.CARTEL_DELETE_FILED:
      return {
        ...state,
        carteles: { ...state.carteles, loading: false, error: action.error },
      }
    case actions.CARTEL_LOAD_BY_ID_REQUESTED:
      return { ...state, cartel: { ...state.cartel, loading: true } }
    case actions.CARTEL_LOAD_BY_ID_SUCCEEDED:
      return { ...state, cartel: { ...state.cartel, data: action.payload, loading: false } }
    case actions.CARTEL_LOAD_BY_ID_FILED:
      return { ...state, cartel: { ...state.cartel, loading: false, error: action.error } }
    default:
      return state
  }
}
